import React, { useEffect, useState } from 'react';
import '../styles.scss';
import { useDispatch, useSelector } from 'react-redux';
import { setWallet, setWalletTransactionList } from '../../../../app/reducers/wallet-slice';
import {
  listWalletTransactions,
  loadWalletInfo,
} from '../../infrastructure/api/wallet.api';

const WalletLayout = (props) => {
  const [isLoaded, setLoaded] = useState(false);
  const dispatch = useDispatch();
  const { user, accessToken } = useSelector((state: any) => state.authorization);

  const getWalletTransactionList = async (wallet) => {
    const response = await listWalletTransactions(wallet.uuid, accessToken);
    if (response.status === 400) return;
    dispatch(setWalletTransactionList(response.data));
  };

  const fetchWalletInfo = async () => {
    const response = await loadWalletInfo(accessToken);
    if (response.status === 400) return;
    dispatch(setWallet(response.data));
    await getWalletTransactionList(response.data);
    setLoaded(true);
  };

  useEffect(() => {
    if (!user) return;
    !isLoaded && fetchWalletInfo();
  }, [user]);

  return <div className="wallet-layout">{isLoaded && props.children}</div>;
};

export default WalletLayout;
